"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConversationFilterSortOrderEnum = void 0;
var ConversationFilterSortOrderEnum;
(function (ConversationFilterSortOrderEnum) {
    ConversationFilterSortOrderEnum["Asc"] = "ASC";
    ConversationFilterSortOrderEnum["Desc"] = "DESC";
})(ConversationFilterSortOrderEnum = exports.ConversationFilterSortOrderEnum || (exports.ConversationFilterSortOrderEnum = {}));
